import React from 'react';
import styled from 'styled-components';
import CloseFilledIcon from 'assets/svgs/CloseFilledIcon';

const Tag = styled.div`
    width: max-content;
    height: 22px;
    border: 0.8px solid #DADADA;
    border-radius: 15.2px;
    background: ${(props) => props.color};
    padding: 3px 8px;
    display: flex;
    align-items: center;
`;

const TagTitle = styled.div<{ textColor: string }>`
    font-size: 14px;
    font-weight: 500px;
    font-family: Roboto;
    line-height: 16px;
    display: inline-flex;
    align-items: center;
    color: ${(props) => props.textColor};
    gap: 4px;
    .icon {
        color: #001760;
        display: inline-flex;
        cursor: pointer;
    }
`;

interface TagProps {
    onClick?: () => void,
    bgColor: string,
    tagTitle: string | [] | Object,
    textColor: string,
    showIcon: boolean,
    icon: React.ReactChild,
}

const Tags: React.FC<TagProps> = ({ onClick, bgColor, tagTitle, textColor, showIcon, icon }) => (
    <>
        <Tag color={bgColor}>
            <TagTitle textColor={textColor} onClick={onClick ? onClick : () => { }}>
                {tagTitle}
                {showIcon &&
                    <span className='icon'>
                        {icon}
                    </span>
                }
            </TagTitle>
        </Tag>
    </>
);


export default Tags;